import { z } from 'zod';

import { defineService } from '@@api/lib/defineService';
import { PaginationParams } from '@@api/utils/schemas/queryParams';
import { paginated } from '@@api/utils/schemas/utils';
import config from '@@config';

import { AbTest, AbTestListItem, AbTestStopped } from './schemas';
import { Metadata } from '../metadata/schemas';

export const abTestsService = defineService(
    (defineEndpoint) => ({
        teaser: {
            getAll: defineEndpoint({
                method: 'GET',
                path: '/teaser',
                query: z.object({
                    ...PaginationParams.shape,
                    q: z.string().optional(),
                    statuses: z.union([z.string(), z.array(z.string())]).optional(),
                }),
                responses: {
                    200: paginated(AbTestListItem),
                },
            }),
            get: defineEndpoint({
                method: 'GET',
                path: '/teaser/:metadataId',
                pathParams: z.object({
                    metadataId: Metadata.shape.id,
                }),
                query: z.object({
                    includeAll: z.boolean().optional(),
                }),
                responses: {
                    200: AbTest,
                    204: z.never(),
                },
            }),
            cancel: defineEndpoint({
                method: 'PATCH',
                path: '/teaser/:metadataId',
                pathParams: z.object({
                    metadataId: Metadata.shape.id,
                }),
                body: z.object({
                    status: z.literal('stopped'),
                }),
                responses: {
                    200: AbTestStopped,
                    204: z.never(),
                },
            }),
        },
    }),
    {
        baseUrl: config.apiEnvVars.abTestUrl,
    },
);
